(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/admin/dialog-adapter/assets/javascripts/helper.js') >= 0) return;  svs.modules.push('/components/admin/dialog-adapter/assets/javascripts/helper.js');
"use strict";


var _svs$components$dialo = svs.components.dialogWrapper.helper,
  button = _svs$components$dialo.button,
  cmsType = _svs$components$dialo.cmsType,
  icon = _svs$components$dialo.icon,
  newDialog = _svs$components$dialo.newDialog,
  text = _svs$components$dialo.text;

var Type = {
  INFO: 'info',
  ERROR: 'error',
  INFOERROR: 'infoerror',
  DEFAULT: 'info'
};

var cmsErrorMessage = function cmsErrorMessage(title, message) {
  newDialog({
    buttons: [button({
      title: 'OK'
    })],
    message: message ? message.map(function (mess) {
      return text({
        text: mess
      });
    }) : [],
    title: title,
    icon: icon[cmsType.ERROR]
  });
};
svs.components.dialogAdapter.helper = {
  Type: Type
};
svs.admin.shared.message.cmsErrorMessage = cmsErrorMessage;

 })(window);